import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import instance from 'connection/instance';
import { NATIONALITIES } from 'config/endpoint';

export const externalNationalityCodesState = {
  data: [],
  isLoading: null,
  error: null,
};

export const getExternalNationalityCodes = createAsyncThunk(
  'externalNationalityCodes/getExternalNationalityCodes',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await instance.get(NATIONALITIES);

      return response.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }

      return rejectWithValue(err.response.data);
    }
  },
);

export const externalNationalityCodesSlice = createSlice({
  name: 'externalNationalityCodes',
  initialState: externalNationalityCodesState,
  reducers: {
    resetExternalNationalityCodes: (state) => {
      state.data = [];
    },
  },
  extraReducers: {
    [getExternalNationalityCodes.pending]: (state) => {
      state.isLoading = true;
    },
    [getExternalNationalityCodes.fulfilled]: (state, action) => {
      const { data } = action.payload;
      state.isLoading = false;
      state.data = data;
    },
    [getExternalNationalityCodes.rejected]: (state, payload) => {
      state.isLoading = false;
      state.error = payload.errors;
    },
  },
});
export const { resetExternalNationalityCodes } = externalNationalityCodesSlice.actions;
export const externalNationalityCodesReducer = externalNationalityCodesSlice.reducer;
